import React from 'react';
import Icon from '../icon/icon';
import './externalLink.css';

export default function ExternalLink({ href, text }) {
    return (
        <a href={href} target="_blank" rel="noopener noreferrer" className='neo-external-link-container'>
            <span className='neo-external-link-text'>{text}</span>
            <Icon name='externalLink'/>
        </a>
    )
}
